import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AddEvaluationTypeWidget from '../../../widgets/evaluationForm/AddEvaluationTypeWidget'
import { getAssessmentConfigType } from '../../../redux/actions/assessment'

export default function AddEvaluationType() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const assessmentCategoryType = location.search.substring(1)

  useEffect(() => {
    handleGetSchema(assessmentCategoryType)
  }, [assessmentCategoryType])

  const handleGetSchema = async (type) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentConfigType(type)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      <AddEvaluationTypeWidget schema={schema} />
    </SidebarProposal>
  )
}
